var React = require('react');

function DePretisKeyvisualWeiss (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M168.4 0L140 67.4h-14.9l25.3-60.2-7.9-3.3-26.7 63.5H15.6L0 105.2l93.2 38.3L121.5 76h14.9L111 136.2l7.9 3.3L145.7 76H246l15.6-37.7L168.4 0zM88.6 132.3l-77.3-31.8L21.4 76h90.8l-23.6 56.3zm151.6-64.9h-90.9L173 11.2 250.4 43l-10.2 24.4z"}));
}

DePretisKeyvisualWeiss.defaultProps = {"viewBox":"0 0 261.6 143.5"};

module.exports = DePretisKeyvisualWeiss;

DePretisKeyvisualWeiss.default = DePretisKeyvisualWeiss;
